export default __webpack_public_path__ + "static/media/e-bunifikasi-picturemark-d.189abb8d.svg";